import '../App.css';
import React, { useEffect } from 'react';
import { auth } from '../firebase.js';
import { useState } from 'react';
import { signInAnonymously } from "firebase/auth";
import { logDemographics, logNewUser, logPostHighlightSurvey, logPostTestSurvey } from '../logging.js';
import { TextField, Flex, Button, Form, Provider, defaultTheme, Text, Heading, Radio, RadioGroup, ContextualHelp, Content, CheckboxGroup, Checkbox, TextArea, Slider } from '@adobe/react-spectrum';

function NudgingPostTestForm({ workerId, participantId, experiment, condition, frequencyWording, passageId, callbacks }) {
    // Results
    const [frequency, setFrequency] = useState(0);
    const [perceivedScore, setPerceivedScore] = useState(0);
    const [otherTools, setOtherTools] = useState('');
    const [additionalComments, setAdditionalComments] = useState('');

    // Validation
    const [formValidated, setFormValidated] = useState(false);

    useEffect(() => {
        validateForm();
    }, [frequency, perceivedScore, otherTools, additionalComments]);

    function validateForm() {
        if (frequency > 0 && perceivedScore > 0 && otherTools !== '' && experiment === "exp2-highlights") {
            setFormValidated(true);
        }

        else if (otherTools !== '' && experiment === "exp3-withinHighlights") {
            setFormValidated(true);
        }

        else {
            setFormValidated(false);
        }
    }

    function submitForm(e) {
        e.preventDefault();

        if (experiment === "exp2-highlights") {
            var results = {
                timestamp: Date.now(),
                workerId: workerId,
                participantId: participantId,
                experiment: experiment,
                condition: condition,
                frequency: frequency,
                perceivedScore: perceivedScore,
                otherTools: otherTools,
                additionalComments: additionalComments,
            }

            logPostTestSurvey(results, callbacks);
        }
        else {
            let results = {
                timestamp: Date.now(),
                workerId: workerId,
                participantId: participantId,
                experiment: experiment,
                otherTools: otherTools,
                additionalComments: additionalComments,
            }

            logPostTestSurvey(results, callbacks);
        }
    }

    return (
        <>
            <Provider theme={defaultTheme} colorScheme='light'>
                <Flex direction="column" justifyContent={'center'} alignItems={"center"}>
                    <div id="textToRead" className='documentReader'>
                        <Heading level={1} width="100%" marginBottom="size-100" marginTop="size-0">Post-Test Questions</Heading>
                        {experiment === "exp2-highlights" ?
                        <Text>Please answer the following questions about your experience writing the test about the passage.  <b>All questions are mandatory unless indicated otherwise.</b></Text>
                        
                        :<Text>Please answer the following questions about your experience writing the tests about the stories.  <b>All questions are mandatory unless indicated otherwise.</b></Text>
                        }
                        <Form onSubmit={e => submitForm(e)}>
                            {experiment === "exp2-highlights" ?
                                <>
                                    {/* Frequency */}
                                    <RadioGroup onChange={setFrequency} marginBottom="size-100" orientation='horizontal' label={<Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">How often did you refer back to the document and your highlights while answering the questions?</Heading>}>
                                        <Text marginEnd={"size-700"} marginTop={"size-50"}>Never</Text>
                                        {[...Array(7)].map((e, i) => <Radio value={(i + 1)}>{(i + 1)}</Radio>)}
                                        <Text marginStart={"size-500"} marginTop={"size-50"}>Very often</Text>
                                    </RadioGroup>


                                    {/* Perceived Score */}
                                    <RadioGroup onChange={setPerceivedScore} marginBottom="size-100" orientation='horizontal' label={<Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">How well do you think you did on the test?</Heading>}>
                                        <Text marginEnd={"size-600"} marginTop={"size-50"}>Failure</Text>
                                        <Text marginEnd={"size-50"}></Text>
                                        {[...Array(7)].map((e, i) => <Radio value={(i + 1)}>{(i + 1)}</Radio>)}
                                        <Text marginStart={"size-500"} marginTop={"size-50"}>Perfect</Text>
                                    </RadioGroup>
                                </>
                                : null}

                            {/* Other studying tools */}
                            <TextArea onChange={setOtherTools} marginBottom="size-100" label={<Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">Did you use any other tools/studying strategies for the test? For example, writing other notes on paper/a separate text editor, looking up its contents online, using the find/search feature of your browser, etc.? Please be honest, this will NOT affect task approval.</Heading>} />

                            {/* Additional Comments */}
                            <TextArea onChange={setAdditionalComments} marginBottom="size-100" label={<Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">Do you have any additional comments about your experience writing the test? If you experienced any technical issues, please describe them below. This will NOT impact task approval. (optional)</Heading>} />

                            <Button variant='primary' type="submit" style='fill' marginTop="size-600" isDisabled={!formValidated}>Submit</Button>
                        </Form>
                    </div>
                </Flex>
            </Provider>
        </>
    );
}

export default NudgingPostTestForm;